<template>
  <div class="content">
    <div class="banner">
      <a class="btn" @click="showContact = true">申请合作</a>
    </div>
    <div class="wrap info">
      <p class="wrap-title">业务优势</p>
      <p class="wrap-p">高效稳定的服务 助力业务的发展</p>
      <ul>
        <li>
          <img src="../assets/images/info1.png" alt>
          <p class="li-title">资源丰富</p>
          <p class="cont">小猪平台有超过80万间房源，<br>分布在全球超过700+座城市。</p>
        </li>
        <li>
          <img src="../assets/images/info2.png" alt>
          <p class="li-title">产品功能全</p>
          <p class="cont">旅游住宿一站式服务，<br>产品全方位覆盖。</p>
        </li>
        <li>
          <img src="../assets/images/info3.png" alt>
          <p class="li-title">合作模式多样</p>
          <p class="cont">提供API和HBA等多种合作模式，<br>覆盖多个行业。</p>
        </li>
        <li>
          <img src="../assets/images/info4.png" alt>
          <p class="li-title">售后支持</p>
          <p class="cont">提供专业售后支持，<br>让合作伙伴无“客服之忧”。</p>
        </li>
      </ul>
    </div>
    <div class="wrap tech">
      <p class="wrap-title">技术能力</p>
      <p class="wrap-p">系统稳定 支持高并发</p>
      <ul>
        <li>
          <img src="../assets/images/tech1.png" alt>
          <p class="li-title">接入快速</p>
          <p class="cont">标准化API接口, 成熟的API设计, <br>易于开发接入和维护。</p>
        </li>
        <li>
          <img src="../assets/images/tech2.png" alt>
          <p class="li-title">场景丰富</p>
          <p class="cont">充分的业务场景API接口支持, <br>数据ms级实时同步和响应。</p>
        </li>
        <li>
          <img src="../assets/images/tech3.png" alt>
          <p class="li-title">性能稳定</p>
          <p class="cont">分布式集群部署, 微服务系统架构设计, 提供高性能和稳定服务。</p>
        </li>
        <li>
          <img src="../assets/images/tech4.png" alt>
          <p class="li-title">技术支持</p>
          <p class="cont">专业技术团队, 资深开发工程师和对接人员, 提供高效的技术支持。</p>
        </li>
      </ul>
    </div>
    <div class="wrap process">
      <p class="wrap-title">接入流程</p>
      <p class="wrap-p">高效稳定的服务助力业务发展</p>
      <ul>
        <li>
          <p class="pro-index">1</p>
          <p class="pro-dec">提交申请</p>
        </li>
        <li>
          <p class="pro-index">2</p>
          <p class="pro-dec">接口开发</p>
        </li>
        <li>
          <p class="pro-index">3</p>
          <p class="pro-dec">接口测试</p>
        </li>
        <li>
          <p class="pro-index">4</p>
          <p class="pro-dec">申请上线</p>
        </li>
      </ul>
    </div>
    <div class="wrap partner">
      <p class="wrap-title">合作伙伴</p>
      <p class="wrap-p">与众多开发者共建民宿生态，合作共赢</p>
      <ul>
        <li>
          <h6>支付宝</h6>
          <p>支付宝（中国）网络技术有限公司是国内的第三方支付平台，致力于为提供“简单、安全、快速”的支付解决方案。</p>
        </li>
        <li>
          <h6>飞猪</h6>
          <p>飞猪，指为淘宝会员提供机票、酒店、旅游线路等商品的综合性旅游出行网络交易服务平台，包括网站及客户端。</p>
        </li>
        <li>
          <h6>马蜂窝</h6>
          <p>马蜂窝旅游网是中国领先的旅行玩乐平台 ，由陈罡和吕刚创立于2006年，从2010年正式开始公司化运营，十年来在旅游UGC内容领域累积了大量的旅游内容。</p>
        </li>
      </ul>
      <div class="list">
        <img src="../assets/images/Logo-cloud.png" alt>
        <img src="../assets/images/Logo-red.png" alt="">
        <img src="../assets/images/Logo-luke.png" alt>
        <img src="../assets/images/Logo-house.png" alt>
        <img src="../assets/images/Logo-qingmang.png" alt>
        <img src="../assets/images/Logo-chengtu.jpg" alt>
        <img src="../assets/images/Logo-tuyouke.png" alt>
        <img src="../assets/images/Logo-yijian.jpg" alt>
        
      </div>
    </div>
    <div class="wrap contact">
      <p class="wrap-title">联系我们</p>
      <p class="address">邮箱：apihezuo@xiaozhu.com   地址: 北京理工大学国防科技园TCL大厦2号楼3层小猪</p>
      <!-- <p class="address">地址: 北京理工大学国防科技园TCL大厦2号楼3层小猪</p> -->
    </div>
    <contact :showDialog.sync="showContact"></contact>
  </div>
</template>

<script>
import contact from "../components/contact.vue";
export default {
  data() {
    return {
      showContact: false
    };
  },
  name: "Home",
  components: {
    contact
  }
};
</script>
<style lang="scss">
.btn {
  display: inline-block;
  width: 360px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 28px;
  color: #fff;
  background-color: #00269a;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  // &:hover{
  //   background: #00269A;
  //   background: rgba(255,255,255,0.20);
  // }
}
</style>
<style lang="scss" scoped>
.content {
  .banner {
    background: url(../assets/images/Back1.jpg) no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: 36.8vw;
    text-align: center;
    .btn {
      margin-top: 23.5vw;
    }
  }
  .wrap {
    width: 100%;
    padding: 60px 0 80px 0;
    .wrap-title {
      font-size: 28px;
      color: #212121;
      text-align: center;
      font-family: PingFangSC-Semibold;
    }
    .wrap-p {
      text-align: center;
      margin-top: 2px;
      font-size: 18px;
      color: #212121;
      font-weight: 300;
    }
    ul {
      display: flex;
      justify-content: center;
      li {
        list-style-type: none;
        display: inline-block;
        text-align: center;
        width: 260px;
        margin: 65px 20px 0px 20px;
        .li-title {
          font-weight: bold;
          color: #00269a;
          font-size: 24px;
        }
        .cont {
          color: #00269a;
          font-size: 16px;
          text-shadow: 0 4px 12px rgba(0, 38, 154, 0.06);
          margin-top: 5px;
        }
      }
    }
  }
  // .info {
  //   background: url(../assets/images/Back2.jpg) no-repeat center center;
  //   background-size: 100% 100%;
  // }
  .tech {
    background: url(../assets/images/Back3.jpg) no-repeat center center;
    background-size: 100% 100%;
    color: #fff;
    .wrap-title {
      color: #fff;
    }
    .wrap-p {
      color: #fff;
    }
    ul {
      li {
        .li-title {
          color: #fff;
        }
        .cont {
          color: #fff;
        }
      }
    }
  }
  .process {
    background: url(../assets/images/Back4.jpg) no-repeat center center;
    background-size: 100% 100%;
    ul {
      li {
        display: inline-block;
        background: url(../assets/images/pot.png) no-repeat center center;
        background-size: 100% 100%;
        width: 220px;
        height: 220px;
        color: #00269a;
        .pro-index {
          font-family: Avenir-Heavy;
          font-size: 80px;
          padding-top: 40px;
        }
        .pro-dec {
          font-weight: bold;
          font-size: 22px;
          margin-top: -5px;
        }
      }
    }
  }
  .partner {
    background: url(../assets/images/Back5.jpg) no-repeat center center;
    background-size: 100% 100%;
    color: #fff;
    .wrap-title {
      color: #fff;
    }
    .wrap-p {
      color: #fff;
    }
    ul {
      li {
        width: 260px;
        height: 350px;
        color: #fff;
        font-weight: normal;
        h6 {
          font-size: 28px;
          margin-top: 100px;
        }
        p {
          font-size: 14px;
          padding: 0 30px;
          margin-top: 20px;
        }
      }
      li:nth-child(1) {
        background: url(../assets/images/Back-3.png) no-repeat center center;
        background-size: 100% 100%;
      }
      li:nth-child(2) {
        background: url(../assets/images/Back-1.png) no-repeat center center;
        background-size: 100% 100%;
      }
      li:nth-child(3) {
        background: url(../assets/images/Back-2.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
    .list {
      width: 100vw;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 80px;
      text-align: center;
      img {
        width: 150px;
        height: 150px;
        margin: 0 6px;
      }
    }
  }
  .contact {
    text-align: center;
    background-color: rgba(37,119,227,.05);
    padding: 30px 0;
    .btn {
      margin-top: 50px;
    }
    .address {
      font-size: 14px;
      color: #212121;
      margin-top: 5px;
    }
  }
}
</style>
